/**
 * Sport pack registry.
 *
 * Adding a sport means adding one entry here and one data module. No change to
 * `core`, `renderer` or the UI. When this becomes `packages/sport-packs/*`, the
 * registry turns into a lazily-imported map with the same shape.
 */

import type { SportPack } from '../core/index.ts';
import { waterPoloPack } from './water-polo/index.ts';

export const SPORT_PACKS: readonly SportPack[] = [waterPoloPack];

export const DEFAULT_SPORT_PACK_ID = waterPoloPack.id;

export function getSportPack(id: string): SportPack {
  const pack = SPORT_PACKS.find((p) => p.id === id);
  if (!pack) throw new Error(`No sport pack registered with id "${id}"`);
  return pack;
}
